import MarkdownRenderer from "../MarkdownRenderer";
import TrackingTimeline from "../TrackingTimeline";

type StoredMessagePayload = {
  type?: string;
  data?: string;
};

const parseStoredMessage = (
  message?: string | null
): StoredMessagePayload | null => {
  if (!message) {
    return null;
  }

  try {
    const parsed = JSON.parse(message);
    if (
      parsed &&
      typeof parsed === "object" &&
      typeof parsed.type === "string" &&
      typeof parsed.data === "string"
    ) {
      return parsed as StoredMessagePayload;
    }
  } catch (_error) {
    return null;
  }

  return null;
};

const StoredMessageView: React.FC<{ message?: string | null }> = ({
  message,
}) => {
  const parsed = parseStoredMessage(message);

  if (!parsed) {
    return <MarkdownRenderer markdown={message ?? ""} />;
  }

  if (parsed.type === "trackingTimeline") {
    try {
      const timeline = JSON.parse(parsed.data ?? "{}");
      return (
        <TrackingTimeline
          summary={timeline.summary ?? ""}
          events={timeline.events ?? []}
        />
      );
    } catch (_error) {
      return <MarkdownRenderer markdown={parsed.data ?? ""} />;
    }
  }

  return <MarkdownRenderer markdown={parsed.data ?? ""} />;
};

export default StoredMessageView;
